import Domain from "../../../models/domain/domain-base";

export class ResetPasswordPolicyOptions extends Domain {
  autoEnrollEnabled = false;
}
